import { useState, useEffect } from 'react'

const useWindowFocus = ({ onFocus, onBlur } = {}) => {
  const [focused, setFocused] = useState(true)

  useEffect(() => {
    setFocused(document.hasFocus())

    const onWindowFocus = () => {
      if (typeof onFocus === 'function') {
        onFocus()
      }
      setFocused(true)
    }
    const onWindowBlur = () => {
      if (typeof onBlur === 'function') {
        onBlur()
      }
      setFocused(false)
    }

    window.addEventListener('focus', onWindowFocus)
    window.addEventListener('blur', onWindowBlur)

    return () => {
      window.removeEventListener('focus', onWindowFocus)
      window.removeEventListener('blur', onWindowBlur)
    }
  }, [])

  return focused
}

export default useWindowFocus
